import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';

type Props = {
  text: string;
};

const Excerpt = ({ text }: Props) => {
  return <Component>{text}</Component>;
};

export default Excerpt;
const Component = styled.div`
  margin: 1.1875rem -15px;
  padding: 1rem 0 1.125rem;
  text-align: center;
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  background: ${colors.gray237};
`;
